export interface IGenericDefaultSelectOption<T = any> {
  value?: T;
  text?: string;
}
export class GenericDefaultSelectOption<T = any> implements IGenericDefaultSelectOption<T> {
  value: T;
  text: string;

  /**
   *
   */
  constructor(text: string, value: T) {
    this.text = text;
    this.value = value;
  }
}


// WEBPACK FOOTER //
// ./src/models/generic/generic-default-select-option.ts